import type { NewsListParams } from "../../admin-api/news";

export const newsQueryKeys = {
	contentModeration: {
		all: ["content-moderation"] as const,
	},
	moderation: {
		all: ["moderation"] as const,
	},
	news: {
		all: ["news"] as const,
		detail: (id: string) => ["news", id] as const,
		list: (params: NewsListParams & { limit: number; offset: number }) =>
			["news", "list", params] as const,
	},
} as const;
